import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@app-core/guards/auth/auth.guard';
import { EulaConsentGuard } from '@app-core/guards/eula-consent/eula-consent.guard';
import { CLIENT_CONFIG } from '@config/config';
import { environment } from '@env/environment';
import { FaceIdResolverResolver } from './resolvers/face-id/face-id-resolver.resolver';
import { GeotabAuthGuard } from '@app-core/guards/geotab-auth/geotab-auth.guard';

export const canActivateGuards = Boolean(environment.isGeotabEnv) ? [GeotabAuthGuard] : [AuthGuard, EulaConsentGuard];

export const routes: Routes = [
  {
    path: 'trips',
    resolve: {
      faceIdEnabled: FaceIdResolverResolver,
    },
    loadChildren: () => import('@app-trips/trips.module').then((m) => m.TripsModule),
    canActivate: canActivateGuards,
  },
  {
    path: 'safety-events',
    loadChildren: () => import('@app-incidents/incidents.module').then((m) => m.IncidentsModule),
    canActivate: canActivateGuards,
  },
  {
    path: 'configurations',
    loadChildren: () => import('@app-asset-config/asset-configuration.module').then((m) => m.AssetConfigurationModule),
    canActivate: canActivateGuards,
  },
  {
    path: 'notification-setting',
    loadChildren: () => import('@app-notification-setting/notification-setting.module').then((m) => m.NotificationSettingModule),
    canActivate: canActivateGuards,
  },
  {
    path: 'drivers',
    resolve: {
      faceIdEnabled: FaceIdResolverResolver,
    },
    loadChildren: () => import('@app-driver-management/driver-management.module').then((m) => m.DriverManagementModule),
    canActivate: canActivateGuards,
  },
  {
    path: 'live-view',
    loadChildren: () => import('@app-live-view/live-view.module').then((m) => m.LiveViewModule),
    canActivate: canActivateGuards,
  },
  {
    path: 'coaching',
    loadChildren: () => import('@app-coaching/coaching.module').then((m) => m.CoachingModule),
    canActivate: canActivateGuards,
  },
  {
    path: 'challenges',
    loadChildren: () => import('@app-challenged/challenged.module').then((m) => m.ChallengedModule),
    canActivate: canActivateGuards,
  },
  {
    path: 'video-requests',
    loadChildren: () => import('@app-dvr/dvr.module').then((m) => m.DvrModule),
    canActivate: canActivateGuards,
  },
  {
    path: 'user-management',
    loadChildren: () => import('@app-user-management/user-management.module').then((m) => m.UserManagementModule),
    canActivate: canActivateGuards,
  },
  {
    path: 'reports',
    loadChildren: () => import('@app-reports/reports.module').then((m) => m.ReportsModule),
    canActivate: canActivateGuards,
  },
  {
    path: 'assets',
    loadChildren: () => import('@app-assets/assets.module').then((m) => m.AssetsModule),
    canActivate: canActivateGuards,
  },
  {
    path: 'diagnostics',
    loadChildren: () => import('@app-diagnostics/diagnostics.module').then((m) => m.DiagnosticsModule),
    canActivate: canActivateGuards,
  },
  {
    path: 'trip-details',
    resolve: {
      faceIdEnabled: FaceIdResolverResolver,
    },
    loadChildren: () => import('@app-trip-details/trip-details.module').then((m) => m.TripDetailsModule),
    canActivate: canActivateGuards,
  },
  {
    path: 'request-video',
    loadChildren: () => import('@app-request-video/request-video.module').then((m) => m.RequestVideoModule),
    canActivate: canActivateGuards,
  },
  {
    path: 'notifications-page',
    loadChildren: () => import('@app-app-notifications/notifications-page.module').then((m) => m.NotificationsPageModule),
    // canActivate: canActivateGuards,
  },
  {
    path: '',
    redirectTo: CLIENT_CONFIG.wildcardRoute,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: CLIENT_CONFIG.wildcardRoute,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled',
      relativeLinkResolution: 'legacy',
      ...(Boolean(environment.isGeotabEnv) ? { initialNavigation: 'disabled' } : {}),
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
